export const VIDEO_CONSTRAINTS = {
     audio: false,
     facingMode: "environment"
}